/*
  Preferiti Pridance — lista lato client, nessun backend.

  Dove vive il dato: localStorage, chiave 'pv2-wishlist', array di HANDLE prodotto.
  Gli handle e non gli id perche' con l'handle si puo' interrogare /products/<handle>.js
  e ottenere titolo, foto, prezzo e disponibilita' aggiornati al momento dell'apertura:
  se un prezzo cambia o un capo va esaurito, la lista non mostra dati vecchi.

  Un'unica implementazione per tutto il sito: cuore sulle card, cuore in pagina
  prodotto, icona nell'header e pannello. Cosi' i vari punti non si contraddicono.
*/
(function () {
  'use strict';

  var KEY = 'pv2-wishlist';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cfg = window.PridanceWishlistConfig || {};
  var moneyFormat = cfg.moneyFormat || '{{amount_with_comma_separator}}';

  /* ---------- storage ---------- */
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      if (!Array.isArray(v)) return [];
      /* Solo stringhe: le prime versioni salvavano id numerici, qui vengono scartati. */
      return v.filter(function (x) { return typeof x === 'string' && x; });
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1;
  }
  function remove(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    write(list);
  }

  /* ---------- formattazione prezzi ---------- */
  /* Il prezzo arriva in centesimi dalle API .js: va reso col formato dello shop,
     altrimenti su un negozio in euro comparirebbe "20.0" invece di "€20,00". */
  function money(cents) {
    var n = (cents || 0) / 100;
    function parts(dec, thousandsSep, decSep) {
      var fixed = n.toFixed(dec);
      var split = fixed.split('.');
      var int = split[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
      return dec ? int + decSep + split[1] : int;
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount': return parts(2, ',', '.');
        case 'amount_no_decimals': return parts(0, ',', '.');
        case 'amount_with_comma_separator': return parts(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return parts(0, '.', ',');
        case 'amount_with_space_separator': return parts(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return parts(0, ' ', ',');
        case 'amount_with_apostrophe_separator': return parts(2, "'", '.');
        default: return parts(2, '.', ',');
      }
    });
  }

  /* ---------- stato visibile ---------- */
  function sync() {
    var list = read();
    document.querySelectorAll('[data-pv2-wish-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-pv2-wish-handle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (label) { btn.setAttribute('aria-label', label); btn.setAttribute('title', label); }
      var txt = btn.querySelector('[data-pv2-wish-text]');
      if (txt && label) { txt.textContent = label; }
    });
    document.querySelectorAll('[data-pv2-wish-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  /* ---------- carrello ---------- */
  function addToCart(items) {
    return fetch(root.replace(/\/$/, '') + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }
  function openCartDrawer() {
    var toggleEl = document.querySelector('.dT_MiniCartModelBtn');
    if (toggleEl) { toggleEl.click(); } else { window.location.href = root.replace(/\/$/, '') + '/cart'; }
  }

  /* ---------- pannello ---------- */
  var panel, listEl, emptyEl, addAllBtn, footerEl;
  function cachePanel() {
    panel = document.querySelector('[data-pv2-wish-panel]');
    if (!panel) return false;
    listEl = panel.querySelector('[data-pv2-wish-list]');
    emptyEl = panel.querySelector('[data-pv2-wish-empty]');
    addAllBtn = panel.querySelector('[data-pv2-wish-addall]');
    footerEl = panel.querySelector('[data-pv2-wish-footer]');
    return true;
  }

  function card(p) {
    /* Prima variante disponibile: se il capo e' esaurito del tutto il bottone si spegne
       ma la riga resta, cosi' l'utente capisce che il preferito esiste ancora. */
    var variant = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) { variant = p.variants[i]; break; }
    }
    var img = p.featured_image || (p.images && p.images[0]);
    var el = document.createElement('div');
    el.className = 'pv2-wish__item' + (variant ? '' : ' is-sold-out');
    el.setAttribute('data-pv2-wish-item', p.handle);
    if (variant) { el.setAttribute('data-variant-id', variant.id); }
    el.innerHTML =
      '<a class="pv2-wish__thumb" href="' + root.replace(/\/$/, '') + '/products/' + p.handle + '">' +
        (img ? '<img src="' + img.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" width="64" height="80" loading="lazy">' : '') +
      '</a>' +
      '<div class="pv2-wish__info">' +
        '<a class="pv2-wish__title" href="' + root.replace(/\/$/, '') + '/products/' + p.handle + '">' + p.title + '</a>' +
        '<span class="pv2-wish__price">' + money(p.price) + '</span>' +
        (variant
          ? '<button type="button" class="pv2-wish__add" data-pv2-wish-add>' + (cfg.addLabel || 'Aggiungi al carrello') + '</button>'
          : '<span class="pv2-wish__soldout">' + (cfg.soldOutLabel || 'Esaurito') + '</span>') +
      '</div>' +
      '<button type="button" class="pv2-wish__remove" data-pv2-wish-remove aria-label="' + (cfg.removeLabel || 'Rimuovi dai preferiti') + '">&times;</button>';
    return el;
  }

  function render() {
    if (!panel && !cachePanel()) return;
    var handles = read();
    listEl.innerHTML = '';
    if (!handles.length) {
      emptyEl.hidden = false;
      if (footerEl) footerEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    listEl.setAttribute('aria-busy', 'true');
    Promise.all(handles.map(function (h) {
      return fetch(root.replace(/\/$/, '') + '/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      listEl.setAttribute('aria-busy', 'false');
      var live = [];
      products.forEach(function (p, i) {
        if (!p) return;              /* prodotto rimosso dal catalogo: si scarta */
        live.push(handles[i]);
        listEl.appendChild(card(p));
      });
      /* Ripulisce la lista dagli handle che non esistono piu', senza avvisi inutili. */
      if (live.length !== handles.length) { write(live); }
      if (footerEl) footerEl.hidden = live.length === 0;
      if (!live.length) { emptyEl.hidden = false; }
    });
  }

  function open() {
    if (!panel && !cachePanel()) return;
    render();
    panel.hidden = false;
    document.documentElement.classList.add('pv2-wish-open');
    var close = panel.querySelector('[data-pv2-wish-close]');
    if (close) close.focus();
  }
  function close() {
    if (!panel) return;
    panel.hidden = true;
    document.documentElement.classList.remove('pv2-wish-open');
  }

  /* ---------- eventi ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-pv2-wish-toggle],[data-pv2-wish-open],[data-pv2-wish-close],[data-pv2-wish-add],[data-pv2-wish-remove],[data-pv2-wish-addall],[data-pv2-wish-overlay]') : null;
    if (!t) return;

    if (t.hasAttribute('data-pv2-wish-toggle')) {
      e.preventDefault();
      toggle(t.getAttribute('data-pv2-wish-handle'));
      if (panel && !panel.hidden) render();
      return;
    }
    if (t.hasAttribute('data-pv2-wish-open')) { e.preventDefault(); open(); return; }
    if (t.hasAttribute('data-pv2-wish-close') || t.hasAttribute('data-pv2-wish-overlay')) { e.preventDefault(); close(); return; }

    if (t.hasAttribute('data-pv2-wish-remove')) {
      e.preventDefault();
      remove(t.closest('[data-pv2-wish-item]').getAttribute('data-pv2-wish-item'));
      render();
      return;
    }
    if (t.hasAttribute('data-pv2-wish-add')) {
      e.preventDefault();
      var row = t.closest('[data-pv2-wish-item]');
      var id = row && row.getAttribute('data-variant-id');
      if (!id) return;
      t.disabled = true;
      addToCart([{ id: Number(id), quantity: 1 }]).then(function (d) {
        t.disabled = false;
        if (d && d.status) { alert(d.description || 'Prodotto non disponibile.'); return; }
        close();
        openCartDrawer();
      }).catch(function () { t.disabled = false; });
      return;
    }
    if (t.hasAttribute('data-pv2-wish-addall')) {
      e.preventDefault();
      var items = [];
      listEl.querySelectorAll('[data-pv2-wish-item][data-variant-id]').forEach(function (row) {
        items.push({ id: Number(row.getAttribute('data-variant-id')), quantity: 1 });
      });
      if (!items.length) return;
      addAllBtn.disabled = true;
      addToCart(items).then(function (d) {
        addAllBtn.disabled = false;
        if (d && d.status) { alert(d.description || 'Alcuni prodotti non sono disponibili.'); return; }
        close();
        openCartDrawer();
      }).catch(function () { addAllBtn.disabled = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel && !panel.hidden) close();
  });
  /* Due schede aperte devono vedere la stessa lista. */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { sync(); if (panel && !panel.hidden) render(); }
  });

  document.addEventListener('DOMContentLoaded', function () { cachePanel(); sync(); });
  sync();

  window.PridanceWishlist = { read: read, has: has, toggle: toggle, open: open, close: close, sync: sync };
})();
